import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import Pre from "@ui/pre/Pre";
import { Badge } from "@ui/badge/Badge";
import { Box, VBox } from "@ui/box/Box";
import { Gauge, Percent, Plug, Settings as SettingsIcon, Store, Users } from "lucide-react";
import Button from "@ui/button/Button";
import { Error } from "@ui/error/Error";
import { Page } from "@ui/page/Page";
import Spacer from "@ui/spacer/Spacer";
import { Spinner } from "@ui/spinner/Spinner";
import { TabItem, Tabs } from "@ui/tabs/Tabs";
import { Typo } from "@ui/text/Typo";
import { checkFeature, TAvailableFeatures } from "src/Featuresmap";
import { GD } from "src/GD";
import { useRouter } from "src/services/Router";
import { IAcquirerChannel } from "src/types/types";
import { Clients } from "../conponents/list/Clients";
import { MerchantsList } from "../conponents/list/MerchantsList";
import { Integrations } from "../forms/Integrations";
import { Settings } from "../forms/Settings";

export const AcquirerChannelPage = () => {
	useLocale();
	//const params = useParams(); // id
	const router = useRouter();
	const acquirerID = router.currentParams.aid;
	const channelID = router.currentParams.cid;

	const [acquirerResponse, , , busy] = GD.REQ_ACQUIRER.useRequest(null, {
		acquirerID: parseInt(acquirerID, 10),
	});
	const acquirer = acquirerResponse?.data ?? null;

	const [channelResponse, , , busyChannel] = GD.REQ_ACQUIRER_CHANNEL.useRequest(null, {
		acquirerID: parseInt(acquirerID, 10),
		channelId: parseInt(channelID, 10),
	});
	const channel = channelResponse?.data ?? null;

	const label = (acquirer?.name ?? "") + ": " + (channel?.title ?? "");

	return (
		<Page
			label={label ?? undefined}
			// rightSection={<RightSectionClients />}
			sectionRightContent={
				<Button
					disabled={!channel || !acquirer}
					variant="primarySmall"
					onClick={function (): void {
						// GD.S_ACQUIRER_EDITOR.invoke({
						// 	acquirerID: acquirer?.id ?? 0,
						// });
						GD.S_ACQUIRER_CHANNEL_EDITOR.invoke({
							channel: channel!.id,
							acquirerID: acquirer!.id,
						});
					}}>{msg("editAcquirerChannel")}</Button>
			}>
			{busy || (busyChannel && <Spinner />)}
			<Error error={acquirerResponse?.error} />
			{acquirer && channel && (
				<VBox>
					<Tabs variant="modern" checkFeature={feature => checkFeature(feature as TAvailableFeatures)}>
						<TabItem title={msg("overview")} icon={<Gauge size={16} />}>
							<OverviewAcquirerChannel channel={channel} />
						</TabItem>

						<TabItem title={msg("clients")} icon={<Users size={16} />}>
							<Clients channelId={parseInt(channelID, 10)} />
						</TabItem>

						<TabItem title={msg("merchants")} icon={<Store size={16} />}>
							<MerchantsList acquirer_id={acquirer.id} channel_id={channel.id} />
						</TabItem>

						{channel?.channel_type !== "individual" ? (
							<TabItem title={msg("integration")} icon={<Plug size={16} />}>
								<Integrations target_id={channel.id} target_type={"channel"} />
							</TabItem>
						) : null}

						<TabItem title={msg("fees_6d80486c")} icon={<Percent size={16} />}>
						</TabItem>

						<TabItem title={msg("settings")} icon={<SettingsIcon size={16} />}>
							<Settings target_id={channel.id} target_type={"channel"} />
						</TabItem>
					</Tabs>
				</VBox>
			)}
		</Page>
	);
};

const OverviewAcquirerChannel = ({ channel }: { channel: IAcquirerChannel }) => {
	useLocale();
	const terminal = GD.REQ_TERMINAL.useRequest(undefined, { terminalID: channel.terminal_id ?? 0 });

	return (
		<Box>
			<Spacer size="20px" />
			<Typo variant={"headMedium"} weight="600" color="textSecondary" block>{msg("info_170322a3")}</Typo>
			<Spacer size="30px" />
			<Box
				sx={{
					display: "grid",
					gap: "20px",
					gridTemplateColumns: "auto 1fr",
				}}>
				<Typo>ID</Typo>
				<Typo>{channel.id}</Typo>

				<Typo>{msg("alias")}</Typo>
				<Typo>{channel.alias}</Typo>

				<Typo>{msg("name")}</Typo>
				<Typo>{channel.title}</Typo>

				<Typo>{msg("status")}</Typo>
				<Badge sx={{ width: "100px" }} label={channel.status ?? msg("unknown_b23a6a84")} />

				<Typo>{msg("type")}</Typo>
				<Badge sx={{ width: "100px" }} label={channel.channel_type ?? msg("unknown_b23a6a84")} />

				<Typo>{msg("terminal")}</Typo>
				{terminal && <Pre data={terminal} wrap />}
			</Box>
		</Box>
	);
};
